import { render, staticRenderFns } from "./shopkeeper-help.vue?vue&type=template&id=5e612159&"
import script from "./shopkeeper-help.vue?vue&type=script&lang=js&"
export * from "./shopkeeper-help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports